import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { jssPreset } from '@material-ui/core';
import { StylesProvider, withStyles } from '@material-ui/styles';
import { createTheme, ThemeProvider } from '@mui/material';
import TextField from '@mui/material/TextField';
import { create } from 'jss';
import rtl from 'jss-rtl';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { IMaskInput } from 'react-imask';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { useSelector } from 'react-redux';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import { IShellConfig } from '../../models/IShellConfig';
import { RootState } from '../../redux/store';
import { ITextPhone } from './ITextPhone';




const CssTextField = withStyles({

    root: {

        '& label': {
            top: "-6px",
        },
        '& label.Mui-focused': {
            color: '#D7DBEC',
        },
        '& .Mui-focused.MuiAutocomplete-input': {
            backgroundColor: "var(--input-bg-color)",
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset legend span': {
                marginRight: 0,
            },
            '& fieldset': {
                borderColor: 'none',
            },
            '&:hover fieldset': {
                borderColor: 'none',
                borderRadius: '8px',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'none',
            },
            '& input:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 1000px transparent inset !important',
                WebkitTextFillColor: 'var(--primary-text-color) !important',
                backgroundColor: 'transparent !important',
                transition: 'background-color 5000s ease-in-out 0s',
                border: 'none'
            },
        },
        "& fieldset": {
            border: "none"
        },
        "& legend": {
            letterSpacing: -2.5,
        },
        "&.MuiOutlinedInput-notchedOutline": { fontSize: "28px" }
    },
})(TextField);
const theme = createTheme({
    direction: 'rtl', // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
    key: 'muiltr',
    stylisPlugins: [prefixer, rtlPlugin],
});
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

const TextMaskCustom = React.forwardRef<HTMLElement, CustomProps>(
    function TextMaskCustom(props, ref) {
        const { onChange, ...other } = props;
        return (
            <IMaskInput
                {...other}
                mask="0`00-00000000"
                definitions={{
                    "0": /[0-9]/,
                }}
                inputRef={ref as any}
                onAccept={(value: string) => {
                    const clean = value.replace(/-/g, "");
                    onChange({ target: { name: props.name, value: clean } });
                }}
                overwrite
            />
        );
    }
);


export default function TextPhone({
    helperText,
    error,
    className,
    id,
    name,
    label,
    value,
    placeHolder,
    onChange,
    onBlur,
    onSelect,
    onFocus,
    setValid
}: ITextPhone) {
    const [jsonFile, setJsonFile] = useState<IShellConfig>();
    const mode = useSelector((state: RootState) => state.theme) as 'light' | 'dark';
    useEffect(() => {
        fetch('/setting/shellConfig.json')
            .then((response) => response.json())
            .then((data) => {
                setJsonFile(data);
            });
    }, []);

    const themeColors = jsonFile?.[mode];

    const displayValue =
        value && value.length === 11
            ? value.replace(/^(\d{3})(\d{8})$/, "$1-$2")
            : value;


    let errorMessage = "";
    if (value.length > 0) {
        if (!value.startsWith("0")) {
            errorMessage = "پیش شماره باید با 0 شروع شود";
        } else if (value.length !== 11) {
            errorMessage = "شماره تلفن باید ۸ رقم پس از پیش شماره داشته باشد";
        }
    }

    const isInvalid = Boolean(errorMessage);
    useEffect(() => {
        if (setValid) {
            setValid(!isInvalid);
        }

    }, [isInvalid]);

    return (
        <StylesProvider jss={jss}>
            <CacheProvider value={cacheRtl}>
                <ThemeProvider theme={theme}>
                    <CssTextField
                        type="tel"
                        style={{
                            width: "100%",
                            backgroundColor: "var(--input-bg-color)",
                            borderRadius: '8px',
                            border: "1px solid var(--border-color)",
                        }}
                        className={
                            error
                                ? '!m-0  rounded-sm  max-h-12'
                                : '!m-0 text-sm !shadow-none  rounded-sm  max-h-12 '
                        }
                        fullWidth
                        label={label}
                        error={isInvalid}
                        onChange={onChange}
                        helperText={errorMessage || helperText}
                        form-control
                        margin="normal"
                        variant="outlined"
                        value={displayValue || ''}
                        InputLabelProps={{
                            className: 'primaryColorLight-100',
                            style: {
                                fontSize: '0.8rem',
                                fontWeight: 'bold',
                                top: '0px',
                                color: themeColors?.primaryColorLight100,

                            },
                        }}
                        InputProps={{
                            inputComponent: TextMaskCustom as any,
                            style: {
                                textAlign: 'center',
                                height: '50px',
                                alignItems: 'center',
                            },

                        }}
                        name={name}
                        id={id}
                        onBlur={onBlur}
                        onSelect={onSelect}
                        sx={{
                            input: {
                                color: themeColors?.primaryColorLight900,
                                fontSize: '14px !important'
                            },
                        }}

                        onFocus={onFocus}

                    />
                </ThemeProvider>
            </CacheProvider>
        </StylesProvider>
    );
}
